<template>
  <div class="OrderView">
      <Order />
  </div>
</template>

<script>
import Order from '@/components/Prime.vue'

export default {
  name: 'OrderView',
  components: {
    Order
  }
}
</script>
